import { style, createVar } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

export const MASQ_BANNER_HEIGHT = '52px';

const backgroundColor = createVar('background-color');
const hoverBackgroundColor = createVar('hover-background-color');
const foregroundColor = createVar('foreground-color');
const dataValueForegroundColor = createVar('data-value-foreground-color');

export const masqueradeBanner = style(
  {
    backgroundColor,
    color: foregroundColor,
    height: MASQ_BANNER_HEIGHT,
    flexShrink: 0,
    overflowY: 'hidden',
    overflowX: 'auto',
    borderBottom: `${themeVars.border['width-0125']} solid ${themeVars.color['border-minimal']}`,

    vars: {
      [backgroundColor]: themeVars.color['surface-base'],
      [hoverBackgroundColor]: themeVars.color['surface-base-hover'],
      [foregroundColor]: themeVars.color['text-bold'],
      [dataValueForegroundColor]: themeVars.color['text-bold'],
    },
  },
  'masquerade-banner',
);

export const masqueradeBannerItemLink = style(
  {
    color: 'currentColor',
    textDecoration: 'none',
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: themeVars.space['150'],
    paddingRight: themeVars.space['150'],
    paddingTop: themeVars.space['050'],
    paddingBottom: themeVars.space['050'],
    borderRadius: themeVars.radius['4'],
    transition: `background-color ${themeVars.motion['duration-fast-01']} ${themeVars.motion['easing-standard-productive']}`,

    selectors: {
      '&:hover, &:active': {
        color: 'currentColor',
        backgroundColor: hoverBackgroundColor,
      },
    },
  },
  'masquerade-banner-item-link',
);

export const masqueradeBannerItem = style(
  {
    selectors: {
      '& + &': {
        borderLeft: `${themeVars.border['width-0125']} solid ${themeVars.color['border-minimal']}`,
      },
    },
  },
  'masquerade-banner-item',
);

const masqueradeBannerInformation = {
  vars: {
    [backgroundColor]: themeVars.color['banner-information-background'],
    [hoverBackgroundColor]: themeVars.color['surface-information-subtle-hover'],
    [foregroundColor]: themeVars.color['text-bold'],
    [dataValueForegroundColor]: themeVars.color['text-information'],
  },
};

const masqueradeBannerCaution = {
  vars: {
    [backgroundColor]: themeVars.color['banner-caution-background'],
    [hoverBackgroundColor]: themeVars.color['surface-caution-subtle-hover'],
    [foregroundColor]: themeVars.color['text-bold'],
    [dataValueForegroundColor]: themeVars.color['text-caution'],
  },
};

const masqueradeBannerCritical = {
  vars: {
    [backgroundColor]: themeVars.color['banner-error-background'],
    [hoverBackgroundColor]: themeVars.color['surface-critical-subtle-hover'],
    [foregroundColor]: themeVars.color['text-bold'],
    [dataValueForegroundColor]: themeVars.color['text-critical'],
  },
};

const masqueradeBannerFree = style(masqueradeBannerInformation, 'masquerade-banner-free');
const masqueradeBannerCurrent = style(masqueradeBannerCaution, 'masquerade-banner-current');
const masqueradeBannerCanceled = style(masqueradeBannerCritical, 'masquerade-banner-canceled');
const masqueradeBannerSuspended = style(masqueradeBannerCritical, 'masquerade-banner-suspended');
const masqueradeBannerOverdue = style(masqueradeBannerCaution, 'masquerade-banner-overdue');
const masqueradeBannerPaymentPending = style(masqueradeBannerCaution, 'masquerade-banner-payment-pending');
const masqueradeBannerDeleted = style(masqueradeBannerCritical, 'masquerade-banner-deleted');
const masqueradeBannerClosed = style(masqueradeBannerCritical, 'masquerade-banner-closed');
const masqueradeBannerTrial = style(masqueradeBannerInformation, 'masquerade-banner-trial');
const masqueradeBannerTrialing = style(masqueradeBannerInformation, 'masquerade-banner-trialing');
const masqueradeBannerLocked = style(masqueradeBannerCritical, 'masquerade-banner-locked');

export const masqueradeBannerContent = style(
  {
    height: '100%',
  },
  'masquerade-banner-content',
);

export const masqueradeBannerModeToggle = style(
  {
    whiteSpace: 'nowrap',
  },
  'masquerade-banner-mode-toggle',
);

export const popoverContentWidth = style(
  {
    width: '360px',
  },
  'popover-content-width',
);

export const accessIconSuccess = style(
  {
    color: themeVars.color['icon-success'],
  },
  'access-icon-success',
);

export const accessIconCritical = style(
  {
    color: themeVars.color['icon-critical'],
  },
  'access-icon-critical',
);

export const masqueradeBannerAllowed = style(
  {
    display: 'flex',
    alignItems: 'center',
    height: MASQ_BANNER_HEIGHT,
    flexShrink: 0,
    borderBottom: `${themeVars.border['width-0125']} solid ${themeVars.color['border-minimal']}`,
  },
  'masquerade-banner-allowed',
);

export const masqFormInput = style(
  {
    width: '168px',
  },
  'masq-form-input',
);

export const accountStateStyles: Record<string, string> = {
  free: masqueradeBannerFree,
  current: masqueradeBannerCurrent,
  canceled: masqueradeBannerCanceled,
  suspended: masqueradeBannerSuspended,
  overdue: masqueradeBannerOverdue,
  payment_pending: masqueradeBannerPaymentPending,
  deleted: masqueradeBannerDeleted,
  closed: masqueradeBannerClosed,
  trial: masqueradeBannerTrial,
  trialing: masqueradeBannerTrialing,
  locked: masqueradeBannerLocked,
};
